import { initializeApp, setLogLevel } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { browserLocalPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB4fWFiG-XH7zUDS6Od4EtceQU787p3ryU",
  authDomain: "wyenfosbills.firebaseapp.com",
  projectId: "wyenfosbills",
  storageBucket: "wyenfosbills.firebasestorage.app",
  messagingSenderId: "615596991593",
  appId: "1:615596991593:web:f4c77bdd0f3eccd8812ef8",
  measurementId: "G-5QQWG5QH9K"
};

const app = initializeApp(firebaseConfig);
setLogLevel('error');

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const analytics = isSupported().then(yes => yes ? getAnalytics(app) : null);
export const messaging = getMessaging(app);

export let firebaseConnectionStatus = 'initializing';
export const setFirebaseConnectionStatus = (status) => {
  firebaseConnectionStatus = status;
};

try {
  auth.setPersistence(browserLocalPersistence);
  // Note: db.settings() is deprecated in Firebase v9+, using enableNetwork/disableNetwork instead
  // db.settings({
  //   ignoreUndefinedProperties: true,
  //   cacheSizeBytes: 40000000,
  // });
} catch (error) {
  console.log('Firebase configuration warning:', error.message);
}

const useEmulators = (process.env.REACT_APP_USE_EMULATORS === 'true' || 
                     localStorage.getItem('useFirebaseEmulators') === 'true') &&
                     (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') &&
                     process.env.NODE_ENV === 'development';

if (useEmulators) {
  try {
    connectAuthEmulator(auth, "http://localhost:9099");
    connectFirestoreEmulator(db, "localhost", 8080);
    connectStorageEmulator(storage, "localhost", 9199);
    connectFunctionsEmulator(functions, "localhost", 5001);
  } catch (error) {
    console.log('Firebase emulators not available:', error.message);
  }
}

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
      });
      return token;
    }
  } catch (error) {
    console.error("Error getting notification permission:", error);
  }
  return null;
};

onMessage(messaging, (payload) => {
  // Handle foreground messages here
});

export default app;